import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-preapp',
	templateUrl: './preapp.component.html',
	styleUrls: ['../focuspay.style.scss'],
})
export class PreappComponent implements OnInit {
	preAppUrl: string = 'https://www.cognitoforms.com/f/5iYMlNB0ckilrcQnwjJbqA/1';
	constructor(private titleService: Title, private activatedRoute: ActivatedRoute) {}

	ngOnInit(): void {
		this.titleService.setTitle('FocusPay Pre-Application');
		const dealerKey = this.activatedRoute.snapshot.queryParamMap.get('dk');
		if (dealerKey) {
			const entry = {
				dealerKey: dealerKey,
			};
			this.preAppUrl += `?entry=${JSON.stringify(entry)}`;
		}
	}
}
